import { put, call, takeEvery } from "redux-saga/effects";
import * as CONST from "./actionTypes";
import * as ACTION from "./actions";
import * as API from "../../Services/ApiCalls";
import { toast } from "react-toastify";

function* deleteFacebookSaga({ payload, callBack }) {
  try {
    const response = yield call(API.DELETE_FACEBOOK, payload);
    callBack && callBack(response);
    if (response.status == 200) {
      yield put(ACTION.deleteFacbook_Success(response.data));
    } else {
      yield put(ACTION.deleteFacbook_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.deleteFacbook_Fail(response.data.error));
  }
}

function* deleteAllFacebookSaga({ payload, callBack }) {
  try {
    const response = yield call(API.DELETEALL_FACEBOOK, payload);
    callBack && callBack(response);
    if (response.status == 200) {
      yield put(ACTION.deleteAllFacbook_Success(response.data));
    } else {
      yield put(ACTION.deleteAllFacbook_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.deleteAllFacbook_Fail(response.data.error));
  }
}

function* deleteInstagramSaga({ payload, callBack }) {
  try {
    const response = yield call(API.DELETE_INSTAGRAM, payload);
    callBack && callBack(response);
    if (response.status == 200) {
      yield put(ACTION.deleteInstagram_Success(response.data));
    } else {
      yield put(ACTION.deleteInstagram_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.deleteInstagram_Fail(response.data.error));
  }
}

function* deleteAllInstagramSaga({ payload, callBack }) {
  try {
    const response = yield call(API.DELETEALL_INSTAGRAM, payload);
    callBack && callBack(response);
    if (response.status == 200) {
      yield put(ACTION.deleteAllInstagram_Success(response.data));
    } else {
      yield put(ACTION.deleteAllInstagram_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.deleteAllInstagram_Fail(response.data.error));
  }
}

function* deleteTwitterSaga({ payload, callBack }) {
  try {
    const response = yield call(API.DELETE_TWITTER, payload);
    callBack && callBack(response);
    if (response.status == 200) {
      yield put(ACTION.deleteTwitter_Success(response.data));
    } else {
      yield put(ACTION.deleteTwitter_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.deleteTwitter_Fail(response.data.error));
  }
}

function* deleteAllTwitterSaga({ payload, callBack }) {
  try {
    const response = yield call(API.DELETEALL_TWITTER, payload);
    callBack && callBack(response);
    if (response.status == 200) {
      yield put(ACTION.deleteAllTwitter_Success(response.data));
    } else {
      yield put(ACTION.deleteAllTwitter_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.deleteAllTwitter_Fail(response.data.error));
  }
}

function* deleteYoutubeSaga({ payload, callBack }) {
  try {
    const response = yield call(API.DELETE_YOUTUBE, payload);
    callBack && callBack(response);
    if (response.status == 200) {
      yield put(ACTION.deleteYoutube_Success(response.data));
    } else {
      yield put(ACTION.deleteYoutube_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.deleteYoutube_Fail(response.data.error));
  }
}

function* deleteAllYoutubeSaga({ payload, callBack }) {
  try {
    const response = yield call(API.DELETEALL_YOUTUBE, payload);
    callBack && callBack(response);
    if (response.status == 200) {
      yield put(ACTION.deleteAllYoutube_Success(response.data));
    } else {
      yield put(ACTION.deleteAllYoutube_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.deleteAllYoutube_Fail(response.data.error));
  }
}

function* deleteTiktokSaga({ payload, callBack }) {
  try {
    const response = yield call(API.DELETE_TIKTOK, payload);
    callBack && callBack(response);
    if (response.status == 200) {
      yield put(ACTION.deleteTiktok_Success(response.data));
    } else {
      yield put(ACTION.deleteTiktok_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.deleteTiktok_Fail(response.data.error));
  }
}

function* deleteAllTiktokSaga({ payload, callBack }) {
  try {
    const response = yield call(API.DELETEALL_TIKTOK, payload);
    callBack && callBack(response);
    if (response.status == 200) {
      yield put(ACTION.deleteAllTiktok_Success(response.data));
    } else {
      yield put(ACTION.deleteAllTiktok_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.deleteAllTiktok_Fail(response.data.error));
  }
}

function* deleteContactSaga({ payload, callBack }) {
  try {
    const response = yield call(API.DELETE_CONTACT, payload);
    callBack && callBack(response);
    if (response.status == 200) {
      yield put(ACTION.deleteContact_Success(response.data));
    } else {
      yield put(ACTION.deleteContact_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.deleteContact_Fail(response.data.error));
  }
}

function* deleteAllContactSaga({ payload, callBack }) {
  try {
    const response = yield call(API.DELETEALL_CONTACT, payload);
    callBack && callBack(response);
    if (response.status == 200) {
      yield put(ACTION.deleteAllContact_Success(response.data));
    } else {
      yield put(ACTION.deleteAllContact_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.deleteAllContact_Fail(response.data.error));
  }
}

function* deleteSubscriberSaga({ payload, callBack }) {
  try {
    const response = yield call(API.DELETE_SUBSCRIBER, payload);
    callBack && callBack(response);
    if (response.status == 200) {
      yield put(ACTION.deleteSubscriber_Success(response.data));
    } else {
      yield put(ACTION.deleteSubscriber_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.deleteSubscriber_Fail(response.data.error));
  }
}

function* deleteAllSubscriberSaga({ payload, callBack }) {
  try {
    const response = yield call(API.DELETEALL_SUBSCRIBER, payload);
    callBack && callBack(response);
    if (response.status == 200) {
      yield put(ACTION.deleteAllSubscriber_Success(response.data));
    } else {
      yield put(ACTION.deleteAllSubscriber_Fail(response.data.error));
    }
  } catch (error) {
    yield put(ACTION.deleteAllSubscriber_Fail(response.data.error));
  }
}

function* DeleteSubscriberSaga() {
  yield takeEvery(CONST.DELETE_FACEBOOK, deleteFacebookSaga);
  yield takeEvery(CONST.DELETEALL_FACEBOOK, deleteAllFacebookSaga);
  yield takeEvery(CONST.DELETE_INSTAGRAM, deleteInstagramSaga);
  yield takeEvery(CONST.DELETEALL_INSTAGRAM, deleteAllInstagramSaga);
  yield takeEvery(CONST.DELETE_TWITTER, deleteTwitterSaga);
  yield takeEvery(CONST.DELETEALL_TWITTER, deleteAllTwitterSaga);
  yield takeEvery(CONST.DELETE_YOUTUBE, deleteYoutubeSaga);
  yield takeEvery(CONST.DELETEALL_YOUTUBE, deleteAllYoutubeSaga);
  yield takeEvery(CONST.DELETE_TIKTOK, deleteTiktokSaga);
  yield takeEvery(CONST.DELETEALL_TIKTOK, deleteAllTiktokSaga);
  yield takeEvery(CONST.DELETE_CONTACT, deleteContactSaga);
  yield takeEvery(CONST.DELETEALL_CONTACT, deleteAllContactSaga);
  yield takeEvery(CONST.DELETE_SUBSCRIBER, deleteSubscriberSaga);
  yield takeEvery(CONST.DELETEALL_SUBSCRIBER, deleteAllSubscriberSaga);
}

export default DeleteSubscriberSaga;
